import { render, staticRenderFns } from "./AdminSessionCard.vue?vue&type=template&id=82fed3f4"
import script from "./AdminSessionCard.vue?vue&type=script&lang=ts"
export * from "./AdminSessionCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports